<template>
  <div>
    <!-- Cheque Books Sidebar -->
    <b-sidebar
      id="sidebar-right"
      :visible="visibility"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      width="450px"
      @hidden="onSidebarHidden"
      class="resource-sidebar"
    >
      <!-- Header -->
      <div class="sidebar-header-modern">
        <div class="sidebar-header-content">
          <div class="sidebar-title-wrapper">
            <feather-icon
              :icon="myObj.id === 0 ? 'PlusIcon' : 'EditIcon'"
              size="20"
              class="sidebar-title-icon"
            />
            <h5 class="mb-0 sidebar-title">{{ $t(sidebarTitle) }}</h5>
          </div>
          <b-button
            variant="outline-secondary"
            size="sm"
            class="sidebar-close-btn"
            @click="visibility = false"
          >
            <feather-icon icon="XIcon" size="16" />
          </b-button>
        </div>
      </div>

      <!-- Body -->
      <div class="sidebar-body-modern">
        <b-form @submit.prevent class="sidebar-form-modern">
          <!-- Account Search Dropdown -->
          <b-form-group :label="$t('Account')" class="modern-form-group">
            <v-select
              ref="acc"
              v-model="myObj.accountID"
              :options="filteredAccList"
              :reduce="(val) => val.id"
              label="title"
              :placeholder="$t('Select account')"
              class="account-select modern-select"
              :filterBy="dropFilter"
              @input="CheckAccount"
            >
              <template #option="option">
                <div class="account-option">
                  <span class="account-name">{{ option.title }}</span>
                  <span class="account-code">{{ option.code }}</span>
                </div>
              </template>
              <template #selected-option="option">
                <div class="account-selected">
                  <span class="account-name-text">{{ option.title }}</span>
                  <span class="account-code-text">{{ option.code }}</span>
                </div>
              </template>
            </v-select>
          </b-form-group>

          <!-- SBU Selection -->
          <b-form-group
            v-if="reportDomain !== 'myskoolfgs' && reportDomain !== 'myskool'"
            :label="$t('SBU')"
            class="modern-form-group"
          >
            <v-select
              ref="project"
              v-model="myObj.projectID"
              :options="projectList"
              :reduce="(val) => val.id"
              label="name"
              :placeholder="$t('Select SBU')"
              class="modern-select"
              @input="CheckSBU"
            />
          </b-form-group>

          <!-- Title Text -->
          <b-form-group :label="$t('Title')" class="modern-form-group">
            <b-form-input
              ref="title"
              v-model="myObj.title"
              :placeholder="$t('Enter title')"
              class="modern-input"
              @blur="CheckTitle"
            />
          </b-form-group>

          <!-- Cheque Numbers Row -->
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('Cheque No. Start')" class="modern-form-group">
                <b-form-input
                  ref="start"
                  v-model="myObj.chequeNoStart"
                  type="number"
                  class="modern-input"
                  @blur="CheckStart"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :label="$t('Cheque No. End')" class="modern-form-group">
                <b-form-input
                  ref="end"
                  v-model="myObj.chequeNoEnd"
                  type="number"
                  class="modern-input"
                  @blur="CheckEnd"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Leafs Row -->
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('Total Leafs')" class="modern-form-group">
                <b-form-input
                  ref="total"
                  v-model="myObj.totalLeafs"
                  type="number"
                  class="modern-input"
                  @blur="CheckTotal"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :label="$t('Remaining Leafs')" class="modern-form-group">
                <b-form-input
                  ref="remain"
                  v-model="myObj.remainingLeafs"
                  type="number"
                  class="modern-input"
                  @blur="CheckRemain"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Last Issued -->
          <b-form-group :label="$t('Last Cheque Issued')" class="modern-form-group">
            <b-form-input
              ref="last"
              v-model="myObj.lastChequeNo"
              type="number"
              class="modern-input"
              @blur="CheckLast"
            />
          </b-form-group>

          <!-- Footer Actions -->
          <div class="sidebar-footer-modern">
            <b-button
              type="submit"
              variant="gradient-primary"
              @click="Add"
              :disabled="request"
              block
              class="modern-btn-submit"
            >
              <b-spinner v-if="request" small class="mr-1" />
              <feather-icon v-else icon="SaveIcon" size="16" class="mr-1" />
              <span class="font-weight-600">{{ $t("Save Cheque Book") }}</span>
            </b-button>
          </div>
        </b-form>
      </div>
    </b-sidebar>

    <!-- Main List Card -->
    <b-card class="leave-requests-list-card">
      <div class="gradient-line-wrapper"></div>


      <!-- Card Header -->
      <div
        class="table-header d-flex flex-wrap justify-content-between align-items-center mb-2 mt-3 px-2"
      >
        <div>
          <h4 class="mb-0 font-weight-bolder">Cheque Books</h4>
          <small class="text-muted"
            >Manage and track your organization's cheque books</small
          >
        </div>
      </div>

      <!-- Filter Row -->
      <b-row class="align-items-center filter-row-single-line mb-3 mt-1 px-1">
        <!-- Search -->
        <b-col md="9" sm="8" cols="12" class="mb-1">
          <div style="position: relative">
            <b-form-input
              v-model.trim="searchQuery"
              :placeholder="$t('Search by title...')"
              class="modern-input"
              style="padding-right: 3rem !important"
            />
            <div
              style="
                position: absolute;
                right: 12px;
                top: 50%;
                transform: translateY(-50%);
                display: flex;
                align-items: center;
              "
            >
              <feather-icon icon="SearchIcon" size="18" class="text-primary" />
            </div>
          </div>
        </b-col>

        <!-- New Cheque Book Button -->
        <b-col md="3" sm="4" cols="12" class="mb-1 text-right d-flex align-items-center">
          <b-button
            @click="PrintSummary(0)"
            variant="outline-primary"
            class="action-btn-outline mr-1"
            style="width: 44px; height: 44px;"
            v-b-tooltip.hover.top
            :title="$t('Summary Report')"
          >
            <feather-icon icon="PrinterIcon" size="18" />
          </b-button>
          <b-button
            @click="AddOpen()"
            variant="gradient-primary"
            class="action-btn-filter w-100"
            style="justify-content: center; height: 44px"
          >
            <feather-icon icon="PlusIcon" size="16" class="mr-50" />
            <span class="font-weight-bold">Cheque Book</span>
          </b-button>
        </b-col>
      </b-row>

      <!-- Pagination Status Bar -->
      <div class="pagination-controls-top mb-1">
        <div class="d-flex align-items-center">
          <div class="page-size-wrapper">
            <label class="page-size-label">{{ $t("Show") }}:</label>
            <v-select
              v-model="perPage"
              :options="pageSizeOptions"
              :reduce="(option) => option.value"
              label="label"
              :clearable="false"
              :searchable="false"
              append-to-body
              class="page-size-select-compact"
              @input="currentPage = 1"
            />
          </div>
        </div>

        <div class="pagination-count-display">
          <span class="count-text">
            Showing <strong>{{ (currentPage - 1) * perPage + 1 }}</strong> to
            <strong>{{ Math.min(currentPage * perPage, filteredItems.length) }}</strong> of
            <strong>{{ filteredItems.length }}</strong> entries
          </span>
        </div>

        <div class="pagination-wrapper-compact">
          <b-pagination
            v-model="currentPage"
            :total-rows="filteredItems.length"
            :per-page="perPage"
            size="sm"
            align="right"
            class="pagination-compact"
          />
        </div>
      </div>

      <!-- Table Section -->
      <div class="table-scroll-container">
        <!-- Top Scrollbar for PC -->
        <div class="table-scrollbar-top" ref="topScrollbar">
          <div class="table-scrollbar-content"></div>
        </div>

        <!-- Table Wrapper -->
        <div class="table-wrapper" ref="tableWrapper" @scroll="syncScroll">
          <b-table
            class="leave-requests-table"
            :items="pagedItems"
            :fields="fields"
            :busy="dataLoading"
            :responsive="false"
            show-empty
            hover
          >
            <template #table-busy>
              <div class="skeleton-table-wrapper">
                <div v-for="n in 5" :key="'skeleton-' + n" class="skeleton-row-item">
                  <div
                    v-for="(field, index) in fields"
                    :key="'skeleton-cell-' + index"
                    class="skeleton-cell-item"
                  >
                    <div class="skeleton-loader"></div>
                  </div>
                </div>
              </div>
            </template>

            <template #head()="data">
              <span>{{ $t(data.label) }}</span>
            </template>

            <!-- S.No -->
            <template #cell(sno)="data">
              <span class="lr-sno-text">{{ (currentPage - 1) * perPage + data.index + 1 }}</span>
            </template>

        <template #cell(title)="data">
          <div class="d-flex align-items-center">
            <b-avatar size="32" variant="light-primary" class="mr-1">
              <feather-icon icon="BookIcon" size="16" />
            </b-avatar>
            <span class="font-weight-600 color-dark" style="color: #2d1b69">{{
              data.value
            }}</span>
          </div>
        </template>

        <template #cell(project)="data">
          <span class="journal-account-title">{{
            getProject(data.item.projectID)
          }}</span>
        </template>

        <template #cell(chequeNoStart)="data">
          <b-badge variant="light-primary" class="journal-num-badge">
            {{ data.value }}
          </b-badge>
        </template>

        <template #cell(chequeNoEnd)="data">
          <b-badge variant="light-info" class="journal-num-badge">
            {{ data.value }}
          </b-badge>
        </template>

        <template #cell(totalLeafs)="data">
          <span class="font-weight-bold" style="color: #2d1b69">{{
            data.value
          }}</span>
        </template>

        <template #cell(remainingLeafs)="data">
          <b-badge
            :variant="data.value < 10 ? 'light-danger' : 'light-success'"
            class="badge-modern"
          >
            {{ data.value }}
          </b-badge>
        </template>

        <template #cell(lastChequeNo)="data">
          <div class="journal-cheque-badge">
            <feather-icon icon="CreditCardIcon" size="11" class="mr-25" />
            {{ data.value }}
          </div>
        </template>

        <template #head(actions)="data">
          <div class="text-right mr-1">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="d-flex align-items-center justify-content-end">
            <!-- Edit -->
            <b-button
              variant="gradient-primary"
              v-b-tooltip.hover.left
              :title="$t('Edit')"
              size="sm"
              class="action-btn-table mr-1"
              @click="Edit(data.item)"
            >
              <feather-icon icon="EditIcon" size="16" />
            </b-button>

            <!-- Print Summary -->
            <b-button
              variant="outline-primary"
              v-b-tooltip.hover.top
              :title="$t('Print Summary')"
              size="sm"
              class="action-btn-outline mr-1"
              @click="PrintSummary(data.item.id)"
            >
              <feather-icon icon="PrinterIcon" size="16" />
            </b-button>

            <!-- Delete -->
            <b-button
              variant="outline-danger"
              v-b-tooltip.hover.right
              :title="$t('Delete')"
              size="sm"
              class="action-btn-outline reject-btn"
              @click="Delete(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" size="16" />
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</b-card>
</div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BSpinner,
  BInputGroupPrepend,
  BFormInput,
  BInputGroup,
  BSidebar,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BTable,
    BBadge,
    BSpinner,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 50,
      pageSizeOptions: [
        { label: "20", value: 20 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
        { label: "200", value: 200 },
      ],
      dataLoading: false,
      items: [],
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      myObj: {
        id: 0,
        accountID: 0,
        projectID: 0,
        title: "",
        chequeNoStart: 0,
        chequeNoEnd: 0,
        totalLeafs: 0,
        remainingLeafs: 0,
        lastChequeNo: 0,
        campusID: this.$store.state.userData.cId,
      },
      searchQuery: "",
      accList: [],
      projectList: [],
      sidebarTitle: "Add Cheque Book",
      visibility: false,
      request: false,
    };
  },
  created() {
    this.LoadData();
    this.LoadAccounts();
    this.LoadProjects();
  },
  computed: {
    filteredItems() {
      if (!this.items) return [];
      return this.items.filter((item) => {
        return (item.title || "")
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
      });
    },
    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },
    fields() {
      const basicFields = [
        { label: "S.NO", key: "sno", tdClass: "sno-cell" },
        { label: "Title", key: "title" },
        { label: "SBU", key: "project" },
        { label: "start", key: "chequeNoStart" },
        { label: "end", key: "chequeNoEnd" },
        { label: "total", key: "totalLeafs" },
        { label: "Remaining", key: "remainingLeafs" },
        { label: "last issued", key: "lastChequeNo" },
        { label: "actions", key: "actions" },
      ];
      if (this.reportDomain === "myskoolfgs" || this.reportDomain === "myskool") {
        return basicFields.filter((f) => f.key !== "project");
      }
      return basicFields;
    },
    filteredAccList() {
      if (!this.accList) return [];
      if (this.reportDomain === "myskoolfgs" || this.reportDomain === "myskool") {
        return this.accList.filter(
          (acc) => acc.cashFlowCategory === "bank_account" && !acc.isParent
        );
      }
      return this.accList;
    },
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    syncScroll(e) {
      if (this.$refs.topScrollbar) {
        this.$refs.topScrollbar.scrollLeft = e.target.scrollLeft;
      }
    },

    dropFilter(opt, label, search) {
      let st = search.toLowerCase();
      return (
        (opt.title && opt.title.toLowerCase().match(st)) ||
        (opt.code && opt.code.toLowerCase().match(st))
      );
    },

    getProject(id) {
      let obj = this.projectList.find((el) => el.id == id);
      return obj ? obj.name : "";
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        accountID: 0,
        projectID: 0,
        title: 0,
        chequeNoStart: 0,
        chequeNoEnd: 0,
        totalLeafs: 0,
        remainingLeafs: 0,
        lastChequeNo: 0,
        campusID: this.$store.state.userData.cId,
      };
      this.visibility = true;
      this.sidebarTitle = "Add Cheque Book";

      var elem = this.$refs["acc"];
      elem.state = undefined;
      var elem = this.$refs["project"];
      elem.state = undefined;
      var elem = this.$refs["start"];
      elem.state = undefined;
      var elem = this.$refs["end"];
      elem.state = undefined;
      var elem = this.$refs["total"];
      elem.state = undefined;
      var elem = this.$refs["remain"];
      elem.state = undefined;
      var elem = this.$refs["last"];
      elem.state = undefined;
    },
    Edit(item) {
      this.myObj = { ...item };
      this.visibility = true;
      this.sidebarTitle = "Edit Cheque Book";

      var elem = this.$refs["acc"];
      elem.state = undefined;
      var elem = this.$refs["project"];
      elem.state = undefined;
      var elem = this.$refs["start"];
      elem.state = undefined;
      var elem = this.$refs["end"];
      elem.state = undefined;
      var elem = this.$refs["total"];
      elem.state = undefined;
      var elem = this.$refs["remain"];
      elem.state = undefined;
      var elem = this.$refs["last"];
      elem.state = undefined;
    },
    PrintSummary(id) {
      const routeData = this.$router.resolve({
        name: "cheque-book-summary-print",
        query: {
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          cheqID: id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    CheckAccount() {
      var elem = this.$refs["acc"];
      if (this.myObj.accountID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSBU() {
      if (
        this.reportDomain === "myskoolfgs" ||
        this.reportDomain === "myskool"
      )
        return true;
      var elem = this.$refs["project"];
      if (!elem) return true;
      if (this.myObj.projectID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTitle() {
      var elem = this.$refs["title"];
      if (!this.myObj.title) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckStart() {
      var elem = this.$refs["start"];
      let x = parseInt(this.myObj.chequeNoStart);
      if (isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        this.myObj.chequeNoStart = x;
        return (elem.state = true);
      }
    },
    CheckEnd() {
      var elem = this.$refs["end"];
      let x = parseInt(this.myObj.chequeNoEnd);
      if (isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        this.myObj.chequeNoEnd = x;
        return (elem.state = true);
      }
    },
    CheckTotal() {
      var elem = this.$refs["total"];
      let x = parseInt(this.myObj.totalLeafs);
      if (isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        this.myObj.totalLeafs = x;
        return (elem.state = true);
      }
    },
    CheckRemain() {
      var elem = this.$refs["remain"];
      let x = parseInt(this.myObj.remainingLeafs);
      if (isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        this.myObj.remainingLeafs = x;
        return (elem.state = true);
      }
    },
    CheckLast() {
      var elem = this.$refs["last"];
      let x = parseInt(this.myObj.lastChequeNo);
      if (isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        this.myObj.lastChequeNo = x;
        return (elem.state = true);
      }
    },
    async Add() {
      const s1 = this.CheckAccount();
      const s2 = this.CheckSBU();
      // const s3 = this.CheckTitle();
      const s4 = this.CheckStart();
      const s5 = this.CheckEnd();
      const s6 = this.CheckTotal();
      const s7 = this.CheckRemain();
      const s8 = this.CheckLast();

      if (
        s1 == false ||
        s2 == false ||
        // s3 == false ||
        s4 == false ||
        s5 == false ||
        s6 == false ||
        s7 == false ||
        s8 == false
      ) {
        this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (this.myObj.chequeNoStart >= this.myObj.chequeNoEnd) {
        this.$bvToast.toast("Invalid cheque no. values entered", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        console.log(this.myObj);
        this.request = true;

        let status = false;
        if (this.myObj.id == 0) {
          status = await this.post({
            url:
              this.$store.state.domain +
              "chequeBooks?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: this.myObj,
            message: "Cheque Book saved successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          status = await this.put({
            url:
              this.$store.state.domain +
              "chequeBooks/" +
              this.myObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Cheque Book updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        }
        this.request = false;

        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      }
    },
    async Delete(id) {
      // console.log(acc);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "chequeBooks/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Cheque Book deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },
    async LoadAccounts() {
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.accList = await this.get(obj);
    },
    async LoadProjects() {
      var obj = {
        url:
          this.$store.state.domain +
          "AccountsDepartment?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.projectList = await this.get(obj);
    },
    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "chequeBooks?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);

      this.dataLoading = false;
    },
    onSidebarHidden() {
      this.visibility = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
/* ---- Premium Container & Header ---- */
.leave-requests-list-card {
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.08) !important;
  border: none;
}
.gradient-line-wrapper {
  height: 4px;
  background: linear-gradient(90deg, #7367f0, #ce9ffc);
  margin: -1.5rem -1.5rem 1rem;
}
.table-header h4 {
  font-size: 1.15rem;
  font-weight: 700;
  color: #2d3748;
}

/* ---- Premium Filter Inputs ---- */
.modern-input {
  border-radius: 10px !important;
  border: 1.5px solid #e0d8ff !important;
  padding: 0.625rem 0.875rem !important;
  height: 44px;
  transition: all 0.2s ease;
  font-weight: 500;
  color: #1e293b;
}
.modern-input:focus {
  border-color: #7c5dfa !important;
  box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1) !important;
  outline: none;
}

.action-btn-filter {
  border-radius: 8px;
  font-size: 0.85rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 10px rgba(115, 103, 240, 0.2) !important;
  transition: transform 0.2s;
}
.action-btn-filter:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(115, 103, 240, 0.3) !important;
}

/* ---- Table Action Buttons ---- */
.action-btn-table {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.action-btn-table:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.action-btn-table:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.action-btn-outline {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  font-weight: 600;
  background: #ffffff !important;
}
.approve-btn {
  border: 2px solid #10b981 !important;
  color: #10b981 !important;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
}
.approve-btn:hover:not(:disabled) {
  background: #f0fdf4 !important;
  border-color: #059669 !important;
  color: #059669 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
}
.reject-btn {
  border: 2px solid #ef4444 !important;
  color: #ef4444 !important;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.15);
}
.reject-btn:hover:not(:disabled) {
  background: #fef2f2 !important;
  border-color: #dc2626 !important;
  color: #dc2626 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
}

/* S.No column */
.lr-sno-text {
  color: #b9b9c3;
  font-size: 0.8rem;
  font-weight: 500;
}
.sno-cell {
  width: 50px;
  min-width: 50px;
}
.actions-cell {
  min-width: 140px;
  text-align: right;
}

/* ---- Pagination Controls ---- */
.pagination-controls-top {
  padding: 0.75rem 1.25rem;
  background: linear-gradient(180deg, #faf9ff 0%, #ffffff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 10px;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  @media (max-width: 992px) {
    flex-wrap: wrap;
    .pagination-count-display {
      order: 3;
      width: 100%;
      text-align: center;
      margin: 0.5rem 0 0 0;
    }
  }
}

.page-size-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  .page-size-label {
    font-size: 0.8125rem;
    font-weight: 600;
    color: #64748b;
    margin: 0;
  }
}

.page-size-select-compact {
  min-width: 75px;
  width: 75px;
  ::v-deep .vs__dropdown-toggle {
    height: 32px !important;
    min-height: 32px !important;
    border-radius: 6px !important;
    border: 1.5px solid #e0d8ff !important;
    padding: 0 8px !important;
    background: #fff !important;
    &:hover { border-color: #b8a9ff !important; }
    &:focus-within {
      border-color: #7c5dfa !important;
      box-shadow: 0 0 0 2px rgba(124, 93, 250, 0.1) !important;
    }
  }
  ::v-deep .vs__selected {
    color: #2d1b69 !important;
    font-weight: 600 !important;
    font-size: 0.8125rem !important;
  }
}

.pagination-count-display {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  .count-text {
    font-size: 0.8125rem;
    color: #64748b;
    font-weight: 500;
    strong {
      color: #7367f0;
      font-weight: 700;
    }
  }
}

.pagination-wrapper-compact {
  ::v-deep .pagination {
    margin-bottom: 0;
    .page-link {
      padding: 0.375rem 0.625rem;
      font-size: 0.8125rem;
      border-radius: 6px;
      margin: 0 2px;
      border: 1px solid #e0d8ff;
      color: #64748b;
      min-width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background: #f3f0ff;
        color: #7c5dfa;
      }
    }
    .page-item.active .page-link {
      background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
      border-color: #7c5dfa;
      color: #fff;
      box-shadow: 0 2px 8px rgba(124, 93, 250, 0.3);
    }
  }
}

/* ---- Scroll Container ---- */
.table-scroll-container {
  position: relative;
  overflow: hidden;
}
.table-scrollbar-top {
  overflow-x: auto;
  overflow-y: hidden;
  height: 10px;
  margin-bottom: 2px;
}
.table-scrollbar-content {
  height: 1px;
}
.table-wrapper {
  overflow-x: auto;
  overflow-y: visible;
}

/* ---- Modern Table Styles ---- */
.leave-requests-table {
  margin-top: 1rem;
  border-radius: 12px;
  overflow: hidden;
  min-width: 100%;
  width: max-content;
  border: 1px solid #e5e7eb;

  ::v-deep th {
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: none;
    font-weight: 700;
    color: #1e293b;
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.5px;
    padding: 0.75rem 0.875rem;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 5;

    &::after {
      display: none;
    }
  }

  ::v-deep td {
    vertical-align: middle;
    border-top: 1px solid #f1f5f9;
    border-bottom: 1px solid #f8fafc;
    padding: 0.75rem 0.875rem;
    background: #ffffff;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    font-size: 0.875rem;
    color: #475569;
    white-space: nowrap;
  }

  ::v-deep tbody tr {
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    position: relative;
    border-left: 3px solid transparent;

    &:nth-child(even) {
      background: #f8fafc;
      td { background: #f8fafc; }
    }

    &:nth-child(odd) {
      background: #ffffff;
      td { background: #ffffff; }
    }

    &:hover {
      background: #f3f0ff !important;
      border-left-color: #7c5dfa;
      td {
        background: #f3f0ff !important;
        color: #2d1b69;
        font-weight: 500;
      }
    }
  }

  ::v-deep .badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
    font-weight: 600;
    line-height: 1.2;
  }
}

/* ---- Premium Skeleton Loader ---- */
.skeleton-table-wrapper {
  display: block;
  width: 100%;
}
.skeleton-row-item {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #f1f5f9;
  animation: skeletonPulse 2s ease-in-out infinite;
  &:nth-child(1) { animation-delay: 0s; }
  &:nth-child(2) { animation-delay: 0.1s; }
  &:nth-child(3) { animation-delay: 0.2s; }
}
.skeleton-cell-item {
  flex: 1;
  padding: 1.1rem 1rem;
  position: relative;
  &::before {
    content: ""; position: absolute; top: 0; left: 0; right: 0; bottom: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(124, 93, 250, 0.03) 50%, transparent 100%);
    animation: skeletonBorderGlow 2.5s ease-in-out infinite;
  }
}
.skeleton-loader {
  height: 18px;
  border-radius: 10px;
  background: linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 25%, #f0f0f0 50%, #f8f8f8 75%, #f0f0f0 100%);
  background-size: 300% 100%;
  animation: skeletonShimmer 2s ease-in-out infinite;
  position: relative;
  overflow: hidden;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

@keyframes skeletonShimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
@keyframes skeletonPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}
@keyframes skeletonBorderGlow {
  0%, 100% { opacity: 0; }
  50% { opacity: 1; }
}

/* ---- Badge Styles ---- */
.badge-modern {
  padding: 0.4rem 0.7rem;
  border-radius: 6px;
  font-weight: 700;
  font-size: 0.75rem;
}

.journal-num-badge {
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.3rem 0.6rem;
}

.journal-account-title {
  font-size: 0.85rem;
  color: #5e5873;
  font-weight: 500;
}

.journal-cheque-badge {
  display: inline-flex;
  align-items: center;
  background: #f3f0ff;
  color: #7367f0;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 0.78rem;
  font-weight: 600;
}

/* ---- Account Dropdown Styles ---- */
.account-select ::v-deep .vs__dropdown-menu {
  max-height: 300px;
  border-radius: 12px;
  border: 1px solid #e0d8ff;
  box-shadow: 0 10px 25px rgba(124, 93, 250, 0.15);
  padding: 8px;
  margin-top: 8px;
}

.account-option {
  padding: 8px 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.account-name {
  font-weight: 600;
  font-size: 14px;
  color: #2d1b69;
}
.account-code {
  font-size: 12px;
  color: #7c5dfa;
  background: #f0edff;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
  align-self: flex-start;
}
.account-selected {
  display: flex;
  align-items: center;
  gap: 8px;
}
.account-name-text {
  font-weight: 600;
}
.account-code-text {
  font-size: 11px;
  background: #f0edff;
  color: #7c5dfa;
  padding: 1px 6px;
  border-radius: 4px;
}

/* ---- Modern Sidebar Styles ---- */
.sidebar-header-modern {
  padding: 1.5rem;
  background: #ffffff;
  border-bottom: 2px solid #f0f0ff;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #7c5dfa 0%, #9d7aff 50%, #cbb9ff 100%);
  }

  .sidebar-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  .sidebar-title-wrapper {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .sidebar-title-icon {
    color: #7c5dfa;
    stroke-width: 2.5;
  }

  .sidebar-title {
    font-size: 1.25rem;
    font-weight: 800;
    color: #2d1b69;
    letter-spacing: -0.3px;
    margin: 0;
  }

  .sidebar-close-btn {
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid #e0d8ff;
    background: #fff;
    color: #64748b;
    transition: all 0.3s ease;

    &:hover {
      background: #f3f0ff;
      border-color: #b8a9ff;
      color: #7c5dfa;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(124, 93, 250, 0.15);
    }
  }
}

.sidebar-body-modern {
  padding: 1.5rem;
  background: #ffffff;
  min-height: calc(100vh - 80px);
}

.sidebar-form-modern {
  .modern-form-group {
    margin-bottom: 1.5rem;

    label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #475569;
      margin-bottom: 0.5rem;
      display: block;
    }
  }

  .modern-input {
    border-radius: 10px;
    border: 1.5px solid #e0d8ff;
    padding: 0.625rem 0.875rem;
    min-height: 44px;
    background: #fff;
    transition: all 0.2s ease;
    color: #1e293b;
    font-weight: 500;
    width: 100%;

    &:hover {
      border-color: #b8a9ff;
    }

    &:focus {
      border-color: #7c5dfa;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
      outline: none;
    }
  }

  .modern-select {
    ::v-deep .vs__dropdown-toggle {
      border-radius: 10px;
      border: 1.5px solid #e0d8ff;
      padding: 0.625rem 0.875rem;
      min-height: 44px;
      background: #fff;
      transition: all 0.2s ease;

      &:hover {
        border-color: #b8a9ff;
      }

      &:focus-within {
        border-color: #7c5dfa;
        box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
      }
    }
  }
}

.sidebar-footer-modern {
  padding: 1.5rem;
  background: #faf9ff;
  border-top: 2px solid #e0d8ff;
  position: sticky;
  bottom: 0;
  margin: 1.5rem -1.5rem -1.5rem -1.5rem;

  .modern-btn-submit {
    border-radius: 10px;
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>
